// extracted by mini-css-extract-plugin
module.exports = {"login":"style_login__1hf3N","form":"style_form__1gyhK","label":"style_label__1PI6L","toolbar":"style_toolbar__17MVN"};